// Menu navigation JavaScript - Team Line Custom Theme

(function() {
  'use strict';

  // Mega Menu Functionality
  const initMegaMenu = () => {
    const menuItems = document.querySelectorAll('.header__menu-item--has-dropdown');
    let activeTimeout = null;
    let activeMenu = null;
    
    if (menuItems.length === 0) return;
    
    const openMegaMenu = (megaMenu, link) => {
      if (activeTimeout) {
        clearTimeout(activeTimeout);
        activeTimeout = null;
      }
      
      // Close other open menus
      document.querySelectorAll('[data-mega-menu].is-active').forEach(menu => {
        if (menu !== megaMenu) {
          menu.classList.remove('is-active');
          const otherLink = menu.closest('.header__menu-item--has-dropdown')?.querySelector('.header__menu-link');
          if (otherLink) otherLink.setAttribute('aria-expanded', 'false');
        }
      });
      
      link.setAttribute('aria-expanded', 'true');
      megaMenu.classList.add('is-active');
      activeMenu = megaMenu;
    };
    
    const closeMegaMenu = (megaMenu, link) => {
      activeTimeout = setTimeout(() => {
        link.setAttribute('aria-expanded', 'false');
        megaMenu.classList.remove('is-active');
        if (activeMenu === megaMenu) {
          activeMenu = null;
        }
      }, 200);
    };
    
    menuItems.forEach((item, index) => {
      const link = item.querySelector('.header__menu-link');
      const megaMenu = item.querySelector('[data-mega-menu]');
      
      if (!link || !megaMenu) return;
      
      // Mouse enter on menu item or link
      const handleEnter = () => {
        if (activeTimeout) {
          clearTimeout(activeTimeout);
          activeTimeout = null;
        }
        
        // Position mega menu below the full header (including promo banner)
        const header = document.querySelector('[data-header]');
        if (header) {
          const headerRect = header.getBoundingClientRect();
          megaMenu.style.position = 'fixed';
          megaMenu.style.top = headerRect.bottom + 'px';
          megaMenu.style.left = '0';
          megaMenu.style.right = '0';
          megaMenu.style.width = '100%';
          megaMenu.style.transform = 'none';
        }
        
        openMegaMenu(megaMenu, link);
      };
      
      // Mouse leave - with delay
      const handleLeave = () => {
        closeMegaMenu(megaMenu, link);
      };
      
      item.addEventListener('mouseenter', handleEnter);
      item.addEventListener('mouseleave', handleLeave);
      megaMenu.addEventListener('mouseenter', handleEnter);
      megaMenu.addEventListener('mouseleave', handleLeave);
      
      // Keyboard navigation
      link.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          const isActive = megaMenu.classList.contains('is-active');
          if (isActive) {
            megaMenu.classList.remove('is-active');
            link.setAttribute('aria-expanded', 'false');
          } else {
            openMegaMenu(megaMenu, link);
          }
        }
        if (e.key === 'Escape') {
          megaMenu.classList.remove('is-active');
          link.setAttribute('aria-expanded', 'false');
        }
      });
    });
    
    // Close mega menus when clicking outside
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.header__menu-item--has-dropdown') && !e.target.closest('[data-mega-menu]')) {
        document.querySelectorAll('[data-mega-menu].is-active').forEach(menu => {
          menu.classList.remove('is-active');
          const link = menu.closest('.header__menu-item--has-dropdown')?.querySelector('.header__menu-link');
          if (link) link.setAttribute('aria-expanded', 'false');
        });
        activeMenu = null;
      }
    });
  };

  // Mobile Menu Functionality
  const initMobileMenu = () => {
    const toggleBtn = document.querySelector('[data-mobile-menu-toggle]');
    const closeBtn = document.querySelector('[data-mobile-menu-close]');
    const mobileMenu = document.querySelector('[data-mobile-menu]');
    const body = document.body;
    
    if (!toggleBtn || !mobileMenu) return;
    
    const openMenu = () => {
      // Store current scroll position before locking body
      const scrollY = window.scrollY;
      body.style.top = `-${scrollY}px`;
      body.classList.add('menu-open');
      mobileMenu.classList.add('is-active');
      toggleBtn.setAttribute('aria-expanded', 'true');
    };
    
    const closeMenu = () => {
      mobileMenu.classList.remove('is-active');
      toggleBtn.setAttribute('aria-expanded', 'false');
      
      // Restore scroll position
      const scrollY = body.style.top;
      body.classList.remove('menu-open');
      body.style.top = '';
      window.scrollTo(0, parseInt(scrollY || '0') * -1);
      
      // Close all submenus
      document.querySelectorAll('[data-mobile-submenu]').forEach(submenu => {
        submenu.classList.remove('is-active');
      });
    };
    
    toggleBtn.addEventListener('click', openMenu);
    if (closeBtn) closeBtn.addEventListener('click', closeMenu);
    
    // Close on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && mobileMenu.classList.contains('is-active')) {
        closeMenu();
      }
    });
    
    // Mobile submenu toggles
    const submenuToggles = document.querySelectorAll('[data-mobile-submenu-toggle]');
    submenuToggles.forEach(toggle => {
      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        const parentItem = toggle.closest('.header__mobile-menu-item, .header__mobile-submenu-item');
        const submenu = parentItem ? parentItem.querySelector('[data-mobile-submenu]') : null;
        if (submenu) {
          const isActive = submenu.classList.contains('is-active');
          // Close other submenus at the same level
          if (parentItem && parentItem.parentElement) {
            const siblings = Array.from(parentItem.parentElement.children);
            siblings.forEach(sibling => {
              if (sibling !== parentItem) {
                const siblingSubmenu = sibling.querySelector('[data-mobile-submenu]');
                if (siblingSubmenu) siblingSubmenu.classList.remove('is-active');
              }
            });
          }
          // Toggle current submenu
          submenu.classList.toggle('is-active', !isActive);
        }
      });
    });
  };


  // Sticky Header
  const initStickyHeader = () => {
    const header = document.querySelector('[data-header]');
    if (!header || !header.classList.contains('header--sticky')) return;
    
    let lastScroll = 0;
    const scrollThreshold = 100;
    
    const handleScroll = () => {
      const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
      
      if (currentScroll > scrollThreshold) {
        header.classList.add('is-scrolled');
        if (currentScroll > lastScroll && currentScroll > 200) {
          header.classList.add('is-hidden');
        } else {
          header.classList.remove('is-hidden');
        }
      } else {
        header.classList.remove('is-scrolled', 'is-hidden');
      }
      
      lastScroll = currentScroll;
    };
    
    window.addEventListener('scroll', handleScroll, { passive: true });
  };

  // Update Cart Count - ensures badge visibility and count are correct
  const updateCartCount = () => {
    const cartCountEls = document.querySelectorAll('[data-cart-count]');
    if (cartCountEls.length === 0) return;
    
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const count = cart.item_count || 0;
        
        cartCountEls.forEach(cartCountEl => {
          // Update text content
          cartCountEl.textContent = count > 0 ? count : '';
          
          // Set data attribute for CSS targeting
          cartCountEl.setAttribute('data-count', count);
          
          // Update parent class for legacy support
          const parent = cartCountEl.closest('.header__action-link--cart');
          if (parent) {
            if (count > 0) {
              parent.classList.add('has-items');
            } else {
              parent.classList.remove('has-items');
            }
          }
        });
      })
      .catch(() => {
        // Silently fail if cart can't be fetched
      });
  };

  // Initialize everything when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initMegaMenu();
      initMobileMenu();
      initStickyHeader();
      updateCartCount();
    });
  } else {
    initMegaMenu();
    initMobileMenu();
    initStickyHeader();
    updateCartCount();
  }

  // Update cart count when cart changes
  document.addEventListener('cart:updated', updateCartCount);
})();
